import classNames from 'classnames';
import {ANIMATION_LATENCY} from 'modules/search-popup/constants';
import React, {FC, useEffect, useRef, useState} from 'react';
import styles from './styles.module.scss';

interface IProps {
    onClose: () => void;
    isVisible: boolean;
}

export const SearchPanelBackdrop: FC<IProps> = ({onClose, isVisible}) => {
    const [componentMounted, setComponentMounted] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        if (isVisible) {
            setComponentMounted(true);
        }
    }, [isVisible]);

    const innerClose = () => {
        setComponentMounted(false);

        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => onClose(), ANIMATION_LATENCY);
    };

    return isVisible ? (
        <div
            className={classNames(styles.backdrop, 'search-panel-backdrop', {
                [styles.backdropVisible]: componentMounted,
            })}
            onClick={innerClose}
            role={'presentation'}
        />
    ) : null;
};
